/**
 * Which of a search box's options it should be offering right now.
 *
 * `typing` carries the whole rule: a box displaying the answer already chosen
 * is not a search for that answer. Filtering on the chosen label turned the
 * 400-odd accounting timezones into a list containing only UTC, and the
 * currencies into a list containing only USD — which reads as a control with
 * one option rather than as a list already sitting on your answer, and is
 * indistinguishable from a broken dropdown.
 *
 * Here rather than beside the component because the component is `.tsx` and
 * this is the part worth pinning: a rendering harness would test React, and
 * this is the decision the bug was in.
 */
export function visibleOptions<T extends { value: string; label: string }>(
  options: readonly T[],
  query: string,
  typing: boolean,
): readonly T[] {
  const needle = typing ? query.trim().toLowerCase() : '';
  if (needle === '') return options;
  return options.filter(
    (o) =>
      o.label.toLowerCase().includes(needle) ||
      o.value.toLowerCase().includes(needle),
  );
}
